import * as Yup from "yup";
import { PhoneRegExp } from "../../../utils/constants";

export const TransportContactFormSchema = Yup.object().shape({
  name: Yup.string().required("Contact name is required"),
  number: Yup.string()
    .matches(PhoneRegExp, "Phone number is not valid")
    .required("Contact number is required"),
});
